const routes = [
  {
    path: "/login",
    component: () => import("../layouts/LoginLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("../pages/LoginPage.vue"),
        name: "BuildingHub Inc. | Login",
       
      },
      {
        path: "/forgot",
        component: () => import("../pages/ForgotPasswordPage.vue"),
        name: "BuildingHub Inc. | Forgot Password",
       
      },
      {
        path: "/register",
        component: () => import("../pages/RegisterPage.vue"),
        name: "BuildingHub Inc. | Register",
       
      },
     
    ]
  },
  {
    path: "/",
    component: () => import("../layouts/MainLayout.vue"),
    meta: {
      authRequired: true
    },
    children: [
      {
        path: "",
        component: () => import("../pages/HomePage.vue"),
        name: "BuildingHub Inc. | Home",
       
      },
      {
        path: "/categories",
        component: () => import("../pages/CategoryListPage.vue"),
        name: "Categories",
       
      },
      {
        path: "/category/:id?",
        component: () => import("../pages/CategoryPage.vue"),
        name: "Category",
       
      }, 
      {
        path: "/lines",
        component: () => import("../pages/ProductLineListPage.vue"),
        name: "Product Lines",
       
      },
      {
        path: "/line/:id?",
        component: () => import("../pages/ProductLinePage.vue"),
        name: "Product Line",
       
      }, 
      {
        path: "/products",
        component: () => import("../pages/ProductListPage.vue"),
        name: "Products",
       
      },
      {
        path: "/product/:id?",
        component: () => import("../pages/ProductPage.vue"),
        name: "Product",
       
      },
      {
        path: "/:catchAll(.*)*",
        component: () => import("../pages/ErrorNotFoundPage.vue"),
        name: "404 Page not Found"
      }, 
    ]
  },
  
  
 
];

export default routes;
